import React, { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { useNavigate} from "react-router-dom";
import { Button, Card } from "react-bootstrap";
import { Loading } from "../../Components/Loading";
import { PrimaryDetailsForm } from "../../Components/Staffs/PrimaryDetailsForm";

const CreateStaff = () => {
  const { get } = useAxios();
  const navigate = useNavigate();
  const [fetching, setFetching] = useState(true);
  const [genders, setGenders] = useState({});
  const [departments, setDepartments] = useState({});
  const [designations, setDesignations] = useState({});
  const [branchLocations, setBranchLocations] = useState({});
  const [maritalStatuses, setMaritalStatuses] = useState({});

  useEffect(() => {
    setFetching(true);
    const getCreateDetails = async () => {
      try {
        const response = await get(`human_resources/staffs/create`);
        setGenders(response.data.gender);
        setDepartments(response.data.departments);
        setBranchLocations(response.data.branches);
        setDesignations(response.data.designation);
        setMaritalStatuses(response.data.maritalStatuses);
      } catch (error) {
        if (error.response.status === 500) {
        }
      } finally {
        setFetching(false);
      }
    };
    getCreateDetails();
  }, []);

  return (
    <>
      <Card className="container">
        {!!fetching ? (
          <Loading />
        ) : (
          <>
            <Card.Header className="d-flex justify-content-between mt-0 mb-5">
              <Card.Title>
                <div className="row">
                  <div className="col-md-12">
                    <h1 className="page-title">
                      Create Employee Personal Details
                    </h1>
                  </div>
                </div>
              </Card.Title>

              <div className="row">
                <div className="col-md-12">
                  <Button onClick={() => navigate(-1)}>Back</Button>
                </div>
              </div>
            </Card.Header>

            <Card.Body>
              <PrimaryDetailsForm
                genders={genders}
                departments={departments}
                designations={designations}
                branchLocations={branchLocations}
                maritalStatuses={maritalStatuses}
              />
            </Card.Body>
          </>
        )}
      </Card>
    </>
  );
};

export default CreateStaff;
